'use client';

import Link from 'next/link';
import { useLanguage } from '@/context/LanguageContext';

const PRIVACY_SECTIONS = [
  {
    titleKey: 'privacyPolicyDoc.section1.title',
    paragraphKeys: [
      'privacyPolicyDoc.section1.clause1',
      'privacyPolicyDoc.section1.clause2',
      'privacyPolicyDoc.section1.clause3',
    ],
  },
  {
    titleKey: 'privacyPolicyDoc.section2.title',
    paragraphKeys: ['privacyPolicyDoc.section2.intro'],
    listKeys: [
      'privacyPolicyDoc.section2.item1',
      'privacyPolicyDoc.section2.item2',
      'privacyPolicyDoc.section2.item3',
      'privacyPolicyDoc.section2.item4',
      'privacyPolicyDoc.section2.item5',
    ],
  },
  {
    titleKey: 'privacyPolicyDoc.section3.title',
    paragraphKeys: [
      'privacyPolicyDoc.section3.clause1',
      'privacyPolicyDoc.section3.clause2',
      'privacyPolicyDoc.section3.clause3',
    ],
  },
  {
    titleKey: 'privacyPolicyDoc.section4.title',
    paragraphKeys: [
      'privacyPolicyDoc.section4.clause1',
      'privacyPolicyDoc.section4.clause2',
      'privacyPolicyDoc.section4.clause3',
    ],
  },
  {
    titleKey: 'privacyPolicyDoc.section5.title',
    paragraphKeys: ['privacyPolicyDoc.section5.intro'],
    listKeys: [
      'privacyPolicyDoc.section5.item1',
      'privacyPolicyDoc.section5.item2',
      'privacyPolicyDoc.section5.item3',
      'privacyPolicyDoc.section5.item4',
    ],
  },
  {
    titleKey: 'privacyPolicyDoc.section6.title',
    paragraphKeys: [
      'privacyPolicyDoc.section6.clause1',
      'privacyPolicyDoc.section6.clause2',
    ],
  },
  {
    titleKey: 'privacyPolicyDoc.section7.title',
    paragraphKeys: [
      'privacyPolicyDoc.section7.clause1',
      'privacyPolicyDoc.section7.clause2',
    ],
  },
  {
    titleKey: 'privacyPolicyDoc.section8.title',
    paragraphKeys: ['privacyPolicyDoc.section8.clause1'],
  },
];

export default function PrivacyPolicyPage() {
  const { t } = useLanguage();

  return (
    <main className="min-h-screen bg-[#0a0a0f] px-4 py-6 text-white sm:px-6 sm:py-8 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 sm:p-7">
          <p className="text-[10px] uppercase tracking-[0.24em] text-brand-300">GreenPro</p>
          <h1 className="mt-2 text-2xl font-black leading-tight sm:text-3xl">{t('privacyPolicyDoc.title')}</h1>
          <p className="mt-3 text-sm text-[hsl(var(--muted-foreground))]">{t('privacyPolicyDoc.lastUpdated')}</p>
          <p className="mt-4 text-sm leading-relaxed text-zinc-300 sm:text-[15px]">{t('privacyPolicyDoc.intro')}</p>
        </div>

        <section className="mt-5 space-y-3 rounded-2xl border border-white/10 bg-white/[0.02] p-4 sm:p-6">
          {PRIVACY_SECTIONS.map((section) => (
            <article key={section.titleKey} className="rounded-xl border border-white/8 bg-black/10 p-4 sm:p-5">
              <h2 className="text-sm font-semibold text-white sm:text-base">{t(section.titleKey)}</h2>
              <div className="mt-3 space-y-2 text-xs leading-relaxed text-[hsl(var(--muted-foreground))] sm:text-sm">
                {section.paragraphKeys.map((paragraphKey) => (
                  <p key={paragraphKey}>{t(paragraphKey)}</p>
                ))}
                {section.listKeys && (
                  <ul className="space-y-2 pl-4">
                    {section.listKeys.map((listKey) => (
                      <li key={listKey} className="list-disc marker:text-brand-300">
                        {t(listKey)}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </article>
          ))}
        </section>

        <div className="mt-6">
          <Link
            href="/login"
            className="inline-flex items-center rounded-lg border border-white/15 bg-white/[0.04] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-white/[0.08]"
          >
            {t('legal.backToLogin')}
          </Link>
        </div>
      </div>
    </main>
  );
}
